import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Title } from 'components/layout'
import styles from './accordion-toggle.styl'

const AccordionToggle = ({
  children,
  className,
  intlKey,
  isActive,
  onClick
}) => (
  <div
    className={cx(styles.title, { [styles.active]: isActive }, className)}
    onClick={onClick}
  >
    <Title h2 intlKey={intlKey}>
      {children}
    </Title>
  </div>
)

AccordionToggle.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  intlKey: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
}

export default AccordionToggle
